var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs flex"},_vm._l((_vm.list),function(item){return _c('div',{key:item.code,class:_vm.currentTab==item.code?'active':'',on:{"click":function($event){return _vm.dealTabs(item.code)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }